import { computed, ref } from 'vue';
import { useMapGetter, useStore } from 'dashboard/composables/store';
import useAutomationValues from 'dashboard/composables/useAutomationValues';
import { usePipelinesStore } from 'dashboard/stores/pipelines';
import { buildFieldGroups, toOptions } from './conditionFields';
import { useMetaPixel } from './useMetaPixel';

// Catálogo de pipelines, agentes, etiquetas, caixas de entrada e atributos usado
// para montar os campos e conferir se o que o fluxo referencia ainda existe.
export const useFlowCatalog = () => {
  const store = useStore();
  const pipelinesStore = usePipelinesStore();
  const attributesByModel = useMapGetter('attributes/getAttributesByModel');
  const agents = useMapGetter('agents/getAgents');
  const { getConditionDropdownValues, getActionDropdownValues } =
    useAutomationValues();
  const { connected: metaConnected } = useMetaPixel();
  const ready = ref(false);

  const load = async () => {
    await Promise.all([
      pipelinesStore.get(),
      store.dispatch('attributes/get'),
      store.dispatch('agents/get'),
      store.dispatch('labels/get'),
      store.dispatch('inboxes/get'),
      store.dispatch('teams/get'),
      store.dispatch('integrations/get'),
    ]);
    ready.value = true;
  };

  const groupsFor = event =>
    buildFieldGroups({
      event,
      customAttributes: {
        contact: attributesByModel.value('contact_attribute'),
        company: attributesByModel.value('company_attribute'),
        deal: attributesByModel.value('deal_attribute'),
      },
      agents: agents.value,
      pipelines: pipelinesStore.getPipelinesList,
      conditionOptions: getConditionDropdownValues,
    });

  const actionOptionsFor = action => toOptions(getActionDropdownValues(action));

  const context = computed(() =>
    ready.value
      ? {
          pipelines: pipelinesStore.getPipelinesList,
          groupsFor,
          metaConnected: metaConnected.value,
        }
      : null
  );

  return { load, ready, groupsFor, actionOptionsFor, context };
};
